// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1W24I","imageUploader":"EGiftCard_imageUploader__1erLL"};